import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Customer } from '../../models/customer';
import { PageBase } from '../page-base';
import { RegisterModel, LoginProvider } from '../../providers/login/login';
import { MenuPage } from '../menu/menu';
import { NavigationListProvider } from '../../providers/navigation-list/navigation-list';
import { AlertProvider } from '../../providers/alert/alert';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage extends PageBase {
  customer = new RegisterModel();
  passwordRepeat: string;

  submitAttempt: boolean;
  registerForm: FormGroup

  constructor(private loginProvider: LoginProvider,
    private navCtrl: NavController,
    private navigationList: NavigationListProvider, 
    private formBuilder: FormBuilder) {
    super();

    this.registerForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mail: ['', Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/), Validators.required])],
// 	    mail: ['', Validators.compose([Validators.pattern(/[a-zA-Z0-9]{4,}/), Validators.required])],
      phone: ['', Validators.compose([Validators.pattern(/^\+(?:[0-9] ?){6,14}[0-9]$/), null])],
      password: ['', Validators.compose([Validators.required])],
      passwordRepeat: ['', Validators.compose([Validators.required])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterPage');
  }

  keyPressHandler(keyCode) 
  {
    if(keyCode == 13) {
      this.register();
    }
  }

  async register() {
    if(!this.registerForm.valid || this.customer.password != this.passwordRepeat) {
      this.submitAttempt = true;
      return;
    }
    this.loginProvider.register(this.customer).then(x => {
      if(!x){
        this.submitAttempt = true;
      } else {
        this.alertProvider.simple('REGISTER.TITLE', 'REGISTER.SUCCESS');
      }
    }).catch(error => {
      this.submitAttempt = true;
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/register/register.ts